
<!--
 * @Author: 仙道
 * @Date: 2022-06-15 21:12:36
 * @LastEditTime: 2022-07-23 23:01:05
 * @email: hao.li08@weimob.com
 * @Description:
 * @FilePath: /iplus-iwt-fe/src/views/equipment/account/modules/components/MeasuringPoint.vue
-->
<template>
  <div class="c-tabs-panel">
    <ModelPointList :deviceData="deviceData" idType="devId" />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import ModelPointList from '@/views/monitor/points/IotModelPointsList.vue'
  export default {
    name: 'MeasuringPoint',
    components: {
      ModelPointList
    },
    props: {
      deviceData: {
        type: Object,
        default: () => { }
      }
    },
    // 定义属性
    data () {
      return {

      }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {
      ...mapGetters([''])
    },
    // 监控data中的数据变化
    watch: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created () {

    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () {

    },
    // 方法集合
    methods: {

    }
  }
</script>

<style lang='scss' scoped>


</style>
